// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-c8544686]{word-break:normal}.center-cards[data-v-c8544686]{display:grid;place-items:center}", ""]);
// Exports
module.exports = exports;
